var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 22.7499C12.1147 22.7499 11.667 22.3022 11.667 21.7499L11.667 12.0833C11.667 11.531 12.1147 11.0833 12.667 11.0833L15.3337 11.0833C15.8859 11.0833 16.3337 11.531 16.3337 12.0833L16.3337 21.7499C16.3337 22.3022 15.8859 22.7499 15.3337 22.7499L12.667 22.7499Z",
    fill: "#0e0333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 6.99996C16.3337 8.28862 15.289 9.33329 14.0003 9.33329C12.7117 9.33329 11.667 8.28862 11.667 6.99996C11.667 5.71129 12.7117 4.66663 14.0003 4.66663C15.289 4.66663 16.3337 5.71129 16.3337 6.99996Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6718ee559311f731d5a9a929fa5d1c13.svg";
export { ForwardRef as ReactComponent };